

import Swiper, { Navigation, Mousewheel } from 'swiper';
//import { Navigation, Mousewheel, Scrollbar } from 'swiper/modules';
/*

クリックで移動するスライダー
自動で横に流れるスライダーというかカルーセルはslide.js
*/


let winW;
let $html = document.querySelector("html");
let isMobile = true;
let clickEvent = 'click';
let currentW;
//let btns = document.querySelector('.swiper-button');

let monitorClassName = 'index-monitor';

let
	$sliderMonitored = document.getElementsByClassName(monitorClassName),
	//$scrollMonitored = document.getElementsByClassName('index-scroll-monitor'),
	sliderOption = { rootMargin: '500px 0px 500px 0px', threshold: 0 },
	//scrollOption = { rootMargin: '-1px 0px', threshold: 0 },
	sliderWatcher,
	//scrollWatcher,

	breakPointS = 480,
	breakPoint = 720,
	breakPointXL = 1280;

let
	interviewSlider,
	landSlider,
	exploreSlider;


// Array.prototype.slice.call(btns, 0).forEach(function (b) {
// 	b.addEventListener('click', function(e){console.log('click'); e.stopPropagation(); return false;});
// });

function setSwiper(id, gap, sp_perview, perview, l_perview, next, prev, afterGap) {


	let sw = new Swiper(id, {
		// containerModifierClass: 'slider-',
		// slideClass: 'slider-item',
		// slideNextClass: 'slider-button-next',
		// slidePrevClass: 'slider-button-prev',
		// wrapperClass: 'slider-wrapper',
		modules: [Navigation, Mousewheel],
		watchOverflow: true,
		spaceBetween: gap,
		slidesPerView: sp_perview,
		breakpoints: {

			480: {
				slidesPerView: perview,
			},
			720: {
				slidesPerView: l_perview,
			}
		},
		//slidesOffsetAfter: afterGap,

		passiveListeners: true,
		mousewheel: {

			forceToAxis: true

		},
		navigation: {
			nextEl: next,
			prevEl: prev,
		}
		// scrollbar: {
		//   el: scrollbar,
		// },

	}, { passive: false });
	return sw;
}

function updateWinW() {
	return window.innerWidth;
}


function sliderObserver(eventName) {

	/*スライダーの監視*/

	if (eventName && eventName === 'resize') {
		if ($sliderMonitored.length !== 0) {
			if (interviewSlider !== void 0) { interviewSlider.destroy(true, true); }
			if (landSlider !== void 0) { landSlider.destroy(true, true); }
			if (exploreSlider !== void 0) { exploreSlider.destroy(true, true); }

			sliderWatcher.disconnect();
			Array.prototype.slice.call($sliderMonitored, 0).forEach(function (imo) {
				imo.classList.remove('inview');
			});
		}
	}

	if ($sliderMonitored) {
		sliderWatcher = new IntersectionObserver(sliderOnOff, sliderOption);

		Array.prototype.slice.call($sliderMonitored, 0).forEach(function (imo) {
			sliderWatcher.observe(imo);
		});
	}

	function sliderOnOff(entries) {

		Array.prototype.slice.call(entries, 0).forEach(function (entry) {
			if (entry.isIntersecting) {
				if (!entry.target.classList.contains('inview')) {
					entry.target.classList.add('inview');

					let customGap = Math.round((winW - 64) / 35) * 2;
					let afterGap = 32;

					if (winW >= breakPoint) {
						customGap = Math.round(winW * 0.9 / 35);
						afterGap = Math.round(winW / 20);
					}

					if (winW >= breakPointXL) {
						customGap = Math.round(winW * 0.8 / 35);
						afterGap = Math.round(winW / 10);
					}

					// console.log('aftergap : ' + afterGap);

					let container = document.getElementById(entry.target.id);
					let containerW = container.clientWidth;
					let containerScrollW = container.scrollWidth;

					if (containerScrollW > containerW) {



						switch (entry.target.id) {
							case 'land-slider':
								landSlider = setSwiper(
									'#land-slider',
									customGap,
									'auto',
									'auto',
									'auto',
									'.land-swiper-next',
									'.land-swiper-prev',
									afterGap
								);
								break;
							case 'interview-slider':
								interviewSlider = setSwiper(
									'#interview-slider',
									customGap,
									1.1,
									1.8,
									2.8,
									'.interview-swiper-next',
									'.interview-swiper-prev',
									afterGap
								);
								break;
							default:
								exploreSlider = setSwiper(
									'#explore-slider',
									customGap,
									2.3,
									4.1,
									4.1,
									'.explore-swiper-next',
									'.explore-swiper-prev',
									afterGap
								);

						}
						let btns = container.querySelectorAll('.swiper-button');
						let image = container.querySelector('.swiper-slide figure');
						let imageH = image.clientHeight;
						Array.prototype.slice.call(btns, 0).forEach((b) => {
							b.style.transform = 'translate(0, ' + ((imageH - b.clientHeight) / 2) + 'px)';
						});

						container.classList.add('swiper-init');

						// console.log(exploreSlider);
						// console.log('END INIT');

					}
					// else {
					// 	console.log('NOT ENOUTH SLIDE');
					// }



				}

			}

		});
	}
}

function setDevice() {
	if ($html.classList.contains('pc')) {
		isMobile = false;
		// clickEvent = 'click';
	}
}

function startSliderObserver(winW, eventName) {
	/*オブザーバースタート（イベント load を渡す）*/
	if ($sliderMonitored.length) {
		sliderObserver(eventName);
	}
}

function updateAll() {
	/*オブザーバー リスタート（イベント resize を渡す）*/
	winW = currentW;
	startSliderObserver(winW, 'resize');

}

function resizeEnd() {
	currentW = updateWinW();

	if (isMobile) {
		if (winW !== currentW) {
			updateAll();
		}
	} else {
		updateAll();
	}
}
window.addEventListener("load", function () {
	winW = updateWinW();
	setDevice();
	startSliderObserver(winW, 'loaded');
});

var timeoutID = 0;
var resize = function () {

	var delay = 400;
	window.addEventListener("resize", function () {
		clearTimeout(timeoutID);
		timeoutID = setTimeout(() => {
			resizeEnd
			setTimeout(() => {
				//console.log('RESIZE END');
				clearTimeout(timeoutID);
			}, 1000);
		}, delay);
	}, false);
};

resize();